import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

export interface ResponseDialogData {
  request: any;
  action: 'approve' | 'reject';
}

@Component({
  selector: 'app-access-request-response-dialog',
  templateUrl: './access-request-response-dialog.component.html',
  styleUrls: ['./access-request-response-dialog.component.scss']
})
export class AccessRequestResponseDialogComponent implements OnInit {
  responseForm: FormGroup;
  action: string;
  request: any;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<AccessRequestResponseDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ResponseDialogData
  ) {
    console.log('Dialog opened with data:', data);
    this.request = data.request;
    this.action = data.action;
  }

  ngOnInit(): void {
    this.responseForm = this.fb.group({
      message: ['', [Validators.maxLength(500)]]
    });
  }

  get title(): string {
    return this.action === 'approve' ? 'Approve Access Request' : 'Reject Access Request';
  }

  get confirmButtonText(): string {
    return this.action === 'approve' ? 'Approve' : 'Reject';
  }

  get confirmButtonColor(): string {
    return this.action === 'approve' ? 'primary' : 'warn';
  }

  get icon(): string {
    return this.action === 'approve' ? 'check_circle' : 'cancel';
  }

  get iconColor(): string {
    return this.action === 'approve' ? '#28a745' : '#dc3545';
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    if (this.responseForm.valid) {
      this.dialogRef.close({
        action: this.action,
        message: this.responseForm.get('message')?.value?.trim() || null
      });
    }
  }

  get messagePlaceholder(): string {
    return this.action === 'approve' 
      ? 'Optional message to include with the approval notification...'
      : 'Optional reason for rejection (this will be sent to the requester)...';
  }

  get messageLabel(): string {
    return this.action === 'approve' 
      ? 'Approval Message (Optional)'
      : 'Rejection Reason (Optional)';
  }

  formatDate(dateString: string): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
  }
}
